"use strict";
/********************************************************************************
  HxSecureString.ts

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxSecureString = void 0;
// Placeholder implementation
var HxSecureString = /** @class */ (function () {
    function HxSecureString(value) {
        this._value = value;
    }
    HxSecureString.prototype.protect = function (value) {
        this._value = value;
    };
    HxSecureString.prototype.unprotect = function () {
        return this._value;
    };
    return HxSecureString;
}());
exports.HxSecureString = HxSecureString;
exports.default = HxSecureString;
